(function ($) {
  'use strict';

  /**
   * Sliders
   * ---
   * Splide.js [https://splidejs.com/]
   */

  // RTL Helper
  var is_rtl = document.dir === 'rtl';
  var slider_dir = is_rtl ? 'rtl' : 'ltr';

  // Reduced Motion Helper
  var mql_reduced_motion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
  var is_reduced_motion = mql_reduced_motion === true
    || mql_reduced_motion.matches === true;


  /**
   * Card Sliders
   * - 3 Cols
   * - Centered Slides
   */

  var slider_cards = document.querySelectorAll( '.js-slider-cards' );

  if ( slider_cards && slider_cards.length ) {
    slider_cards.forEach(function ( this_slider ) {

      var this_slides = this_slider.querySelectorAll( '.splide__slide' );
      var slider_type = 'slide';
      var slider_arrows = false;
      var is_disabled = true;

      if ( this_slides.length >= 3 ) {
        slider_type = 'loop';
        slider_arrows = true;
        is_disabled = false;
      }

      new Splide( this_slider, {
        // Slider Config
        type: slider_type,
        arrows: slider_arrows,
        perPage: 1,
        focus: 'center',
        autoWidth: true,
        // Styles
        gap: '1.25rem',
        padding: '4.375rem',
        direction: slider_dir,
        destroy: is_disabled,
        breakpoints: {
          760: {
            destroy: false,
            type: 'loop',
            arrows: true,
          },
        },
      }).mount();
    });
  }


  /**
   * Generic Quote Slider
   */

  var slider_quotes = document.querySelectorAll( '.js-slider-quotes' );

  if ( slider_quotes && slider_quotes.length ) {
    slider_quotes.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        // Slider Config
        type: 'loop',
        perPage: 1,
        arrows: true,
        focus: 'center',
        autoWidth: true,
        // Styles
        gap: '1.25rem',
        direction: slider_dir,
        // MQ Breakpoints (Max-Width, from mobile -> desktop)
        breakpoints: {
          760: {
            perPage: 1,
            arrows: false,
          },
        },
      }).mount();
    });
  }

})(jQuery);
